/**
 * Created by OLD on 18/10/2015.
 */
define('timetrackerPopupView',[
  'module',
  'marionette',
  'app',
  'backbone',
  'underscore',
  'dialogView',
  'template!timetrackerPopupTpl',
  'imageUtils',
  'moment'
], function(
  module,
  Marionette,
  App,
  Backbone,
  _,
  DialogView,
  viewTpl,
  imageUtils,
  moment
) {
  'use strict';

  var TimetrackerDialog = DialogView.extend({
    template: viewTpl,

    ui: {
      screenItem: '.json-calendar-image',
      screenBlock: '.timetracking-image-in-popup'
    },

    events: {
      'click @ui.screenItem' : 'onZoom'
    },

    serializeData: function() {
      var templateData = {};

      templateData.logonId = this.options.logonId;
      templateData.screens = _.sortBy(this.model.toJSON(), function(item) {
        return item.end;
      });

      _.each(templateData.screens, function(screen) {
        _.each(screen.snaptshots, function(snapshot) {
          snapshot.fileUrl = imageUtils.getLogo(snapshot.fileUid);
          snapshot.dateTime = moment(snapshot.date).format('YYYY-MM-DD HH:mm:ss');
        });
      });

      return templateData;
    },

    onZoom: function(e) {
      var uid = $(e.currentTarget).attr('data-file-uid');

      this.trigger('timetracker:onZoom', uid);    
    },

    onDelete: function(e) {
      var secId = $(e.currentTarget).attr('data-secid'),
        uid = $(e.currentTarget).attr('data-uid'),
        screens = this.model.toJSON(),
        arr = [];

      var data = _.map(screens, function(item) {
          if (item.secId === secId) {
            arr = _.without(item.snaptshots, _.find(item.snaptshots, {fileUid: uid}));
          } else {
            arr = item.snaptshots;
          }
          return {
            end: item.end,
            secId: item.secId,
            snaptshots: arr,
            start: item.start,
            user: item.user,
            task: item.task
          };
      });
      this.model =  new Backbone.Model(data);
      this.trigger('timetracker:onDelete', secId, uid);
    }
  });

  module.exports = TimetrackerDialog;
});
